import request from './request'
//登录接口
export function signUp(data,remberMe) {
    return request({
        url: `/login/processing`,
        method: "post",
        data: data
    })
}
//退出接口
export function logout(params,data) {
    return request({
        url: "/logout",
        method: "get",
        params,
        data: data
    })
}
//菜单接口
export function getMenuList(data) {
    return request({
        url: "/menu/list/user",
        method: "get",
        data: data
    })
}
//个人信息查询
export function personalInfo(params,data) {
    return request({
        url: "/user/self",
        method: "get",
        params,
        data
    })  
}
//查询所有权限
export function getMenuAll(params) {
    return request({
        url: "/menu/list/all",
        method: "get",
        params,
    })
}
//上传凭证
export function uploadVoucher(params) {
    return request({
        url: "/upload/voucher",
        method: "post",
        params,
    })
}
//查询所有品名
export function goodsNameAll(name,type) {
    return request({
        url: `/dict/goods_name/list/all?name=${name}&type=${type}`,
        method: "get",
    })
}

//查询所有收货地
export function receiveAll(name,type) {
    return request({
        url: `/dict/receive/list/all?name=${name}&type=${type}`,
        method: "get",
    })
}
//查询所有发货地
export function sendAll(name,type) {
    return request({
        url: `/dict/send/list/all?name=${name}&type=${type}`,
        method: "get",
    })
}